"use client";

import { Mail, Plus } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Inquiries() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const faqs = [{
    question: "What is the purity standard of your peptides?",
    answer: "We maintain an industry-leading purity standard of 99% or higher. Every batch undergoes rigorous HPLC and MS testing to ensure the molecular integrity required for elite research applications.",
    specs: ["HPLC verified purity", "Mass spectrometry validated", "Batch-specific documentation"]
  }, {
    question: "How are your products stored and shipped?",
    answer: "To preserve peptide stability, all inventory is kept in climate-controlled, light-protected environments. We utilize cold-chain logistics to ensure your research materials arrive in optimal condition.",
    specs: ["Cold-storage protocols", "Light-protected packaging", "Climate-controlled transit"]
  }, {
    question: "Do you provide Certificates of Analysis (COA)?",
    answer: "Yes. Every product batch is accompanied by a verifiable Certificate of Analysis. You can access these documents directly through our secure verification portal using your batch number.",
    specs: []
  }, {
    question: "What is the Iron Habit quality philosophy?",
    answer: "Precision is our baseline. We reject the 'good enough' mentality of mass-market suppliers, focusing instead on laboratory-grade consistency that researchers can rely on for high-stakes performance studies.",
    specs: []
  }, {
    question: "Where is your facility located?",
    answer: "Iron Habit Peptides operates out of a high-security, specialized laboratory facility. We prioritize domestic sourcing and processing to maintain total control over our supply chain.",
    specs: ["Domestic laboratory facility", "Strict quality oversight", "Secure supply chain"]
  }, {
    question: "How do you handle bulk research orders?",
    answer: "We offer streamlined procurement for institutional and high-volume research partners. Contact our support team to discuss custom batch requirements and volume-based pricing structures.",
    specs: []
  }, {
    question: "Can I verify my specific batch online?",
    answer: "Absolutely. Our Verification Hub allows you to input your unique batch ID to pull up the exact testing data for the product you received, ensuring full transparency.",
    specs: []
  }, {
    question: "How do we initiate a research partnership?",
    answer: "Reach out via our support portal or email. We will review your research requirements and provide a formal consultation to ensure our peptide specifications align with your study parameters.",
    specs: ["Step 1: Submit inquiry", "Step 2: Technical review", "Step 3: Procurement setup"]
  }];
  return;
}